<template>
<div class="section">
    <div class="container content-area">
        <h1 :class="['title is-5 is-uppercase', {'is-hidden': site_data.rows}]">{{site_data.title}}</h1>
        <div :class="['collections columns is-multiline', {'is-mobile': !is_mobile}]">
            <aside v-if="is_mobile" class="column is-offset-1 is-sticky">
                <SearchForm :action="site_data.siteconfig.search_page" />
                <p class="help"><strong>{{site_data.collections.count}}</strong> item(s) found. <router-link :to="site_data.siteconfig.search_page" v-if="$route.query.term">Clear result</router-link></p>
            </aside>
            <div class="column is-7">
                <template v-if="site_data.rows.length && !$route.query.term">
                    <ContentRow :is_mobile="is_mobile" v-for="row, i in site_data.rows" :key="i" :row="row" />
                    <hr />
                </template>
                <template v-if="$route.query.term && !site_data.collections.list.length">
                    <h2 class="title is-5">No Result</h2>
                    <div class="content">
                        <p>Sorry, we cannot find any result that matches your search term. Please retry with a different keyword.</p>
                    </div>
                </template>
                <router-link class="collection is-block" :to="item.url" v-for="item, i in site_data.collections.list" :key="'collection-' + i">
                    <div class="collection__inner">
                        <h2 class="title is-5">{{item.title}}</h2>
                        <p class="subtitle is-7" v-if="item.ref || item.creator">
                            <template v-if="item.creator"><strong>{{item.org_titles}}</strong>: {{item.creator}} <span v-if="item.ref">|</span></template>
                            <template v-if="item.ref"><strong>Reference</strong>: {{item.ref}}</template>
                        </p>
                        <div class="content" v-html="item.content"></div>
                        <div class="content">
                            <p><template v-if="item.aliases"><strong>Other names</strong>: {{item.aliases}}<br /></template><strong>Dates covered</strong>: <template v-if="item.first || item.last">{{item.first}}<template v-if="item.last"> - {{item.last}}</template></template><em v-else>not specified</em></p>
                        </div>
                    </div>
                </router-link>
            </div>
            <aside v-if="!is_mobile" class="column is-offset-1">
                <div class="is-sticky">
                    <SearchForm :action="site_data.siteconfig.search_page" />
                    <p class="help"><strong>{{site_data.collections.count}}</strong> item(s) found. <router-link :to="site_data.siteconfig.search_page" v-if="$route.query.term">Clear result</router-link></p>
                </div>
            </aside>
        </div>
        <Pagination :collections="site_data.collections" />
    </div>
</div>
</template>

<script>
import Pagination from '../blocks/Pagination';
import SearchForm from '../blocks/forms/SearchForm';
import ContentRow from '../blocks/ContentRow';
export default {
    name        :   'ArchiveLandingPage',
    props       :   ['site_data', 'is_mobile'],
    components  :   { Pagination, SearchForm, ContentRow }
    // 'title'
    // 'url'
    // 'ref'
    // 'content'
    // 'first'
    // 'last'
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ArchiveLandingPage.vue